<template>
    <b-container>
        <b-row>
            <b-col cols="12" class="p-2 d-flex justify-content-between">
                <h1>Users</h1>
                <div class="w-25 flex-center">
                    <b-btn variant="primary"
                           class="w-100"
                           v-b-modal.new-user>New User</b-btn>
                </div>
            </b-col>
            <b-col>
                <adam-table
                        position
                        :items="users"
                        :fields="fields"
                        :search-keys="searchKeys"
                        @rowClicked="editUser"
                        class="white-bg">
                </adam-table>
            </b-col>
            <b-modal centered
                     ref="new-user"
                     title="Create user"
                     id="new-user"
                     hide-footer>
                <adam-form :fields="formFields"
                              submit="Create"
                              post="register"
                              @success="formSuccess">
                </adam-form>
            </b-modal>
            <b-modal centered
                     hide-footer
                     ref="edit-user"
                     title="Edit user"
                     id="edit-user">
                <adam-form
                        v-if="selectedUser"
                        :fields="formFields"
                        submit="Update"
                        :post="'users' + '/' + selectedUser.id"
                        :item="selectedUser"
                        @success="formSuccess">
                </adam-form>
            </b-modal>
        </b-row>
    </b-container>
</template>

<script>
    import AdamForm from "../components/AdamForm";
    import AdamTable from "../components/AdamTable";
    export default {
        components: {AdamTable, AdamForm},
        data() {
            return {
                selectedUser: null,
                users: [],
                companies: [],
                fields: [
                    {
                        key: 'name',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'email',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'company.name',
                        label: 'Company',
                        sortable: true
                    }
                ],
                searchKeys: [
                    'name'
                ],
                formFields: [
                    {
                        key: 'company_id',
                        label: 'Company',
                        type: 'select',
                        required: true,
                        options: []
                    },
                    {
                        key: 'name',
                        label: 'Name',
                        type: 'text',
                        required: true
                    },
                    {
                        key: 'email',
                        label: 'Email',
                        type: 'email',
                        required: true
                    },
                    {
                        key: 'password',
                        label: 'Password',
                        type: 'password',
                        required: true
                    },
                    {
                        key: 'password_confirmation',
                        label: 'Confirm password',
                        type: 'password',
                        required: true
                    },
                ]
            }
        },
        computed: {
            user() {
                return this.$store.getters.loggedUser;
            }
        },
        methods: {
            getUsers() {
                adamApi.get('users').then(response => {
                        this.users = response.data;
                    }
                );
            },
            formSuccess() {
                this.getUsers();
                this.$refs['new-user'].hide();
            },
            editUser(id) {
                this.formFields[3].required = false;
                this.formFields[4].required = false;
                this.formFields[3].hidden = true;
                this.formFields[4].hidden = true;
                this.selectedUser = this.users.find(user => {return user.id === id});
                this.$refs['edit-user'].show();
            }
        },
        created() {
            this.getUsers();
            adamApi.get(api.companies).then(response => {
                    this.companies = response.data;
                    this.companies.forEach(company => {
                        this.formFields[0].options.push(
                            {
                                text: company.name,
                                value: company.id
                            }
                        )
                    });
                }
            );
        }
    }
</script>